import React from "react";

import { QuestionnaireConfigurationTabUpdateDto } from "@common/dto/questionnaire/configuration-tab";
import { ConfigurationProps } from "./configuration.types";
import { I18n } from "react-redux-i18n";

export const useConfigurationController = (props: ConfigurationProps) => {
  const configurationTemplates: Array<
    Array<{ id: keyof QuestionnaireConfigurationTabUpdateDto; label: string }>
  > = [
    [{ id: "helpText", label: I18n.t("Help Text") }],
    [{ id: "loginTitle", label: I18n.t("Login Page Title") }],
    [
      { id: "loginInstructions", label: I18n.t("Login Page Instructions") },
      {
        id: "signupInstructions",
        label: I18n.t("Sign Up Page Instructions"),
      },
    ],
    [
      { id: "summaryTitle", label: I18n.t("Summary Title") },
      { id: "summaryText", label: I18n.t("Summary Text") },
    ],
    [
      { id: "submitTitle", label: I18n.t("Submit Popup Title") },
      { id: "submitText", label: I18n.t("Submit Popup Text") },
    ],
  ];

  const handleTemplateChange = React.useCallback(
    (key: keyof QuestionnaireConfigurationTabUpdateDto) => (val: string) => {
      props.onChange({
        ...props.questionnaire,
        configurationTab: {
          ...props.questionnaire.configurationTab,
          [key]: val,
        }
      });
    },
    [props.onChange, props.questionnaire]
  );

  return { handleTemplateChange, configurationTemplates };
};
